import React, { Component } from 'react'
import ContentHeader from '../../components/ContentHeader'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
    getSettings,
    updateSettings
} from '../../modules/settings'
import '../../styles/css/settings.css'

class Settings extends Component {
    
    constructor(props){
        super(props)
        this.state = {
            addHeadline: false,
            settings: {}
        }
    }

    componentWillMount() {
        this.props.getSettings()
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            settings: nextProps.settings
        })
    }

    deleteHeadline = headline => {
        this.setState({
            settings: {
                ...this.state.settings,
                header_headlines: this.state.settings.header_headlines.filter(h => h !== headline)
            }
        })
    }

    toggleAddHeadline = () => {
        this.setState({
            addHeadline: !this.state.addHeadline
        })
    }

    handleAddHeadline = () => {
        this.setState({
            settings: {
                ...this.state.settings,
                header_headlines: [ ...this.state.settings.header_headlines, this.refs.newHeadline.value ],
            },
            addHeadline: false
        })
    }

    handleSocialInput = ({ target: { name,value } }) => {
        this.setState({
            settings: {
                ...this.state.settings,
                social_links: {
                    ...this.state.settings.social_links,
                    [name]: value
                }
            }
        })
    }

    handleEmailReceiverInput = ({ target: { value } }) => {
        this.setState({
            settings: {
                ...this.state.settings,
                email_receiver: value
            }
        })
    }

    render() {
        const { settings: { 
                social_links = {}, 
                header_headlines = [], 
                email_receiver = '' }, addHeadline } = this.state
        const { updateSettings, updated } = this.props
        return(
            <div id="content">
                
                <ContentHeader 
                    title="Settings" 
                    buttonTitle={updated ? 'Changes saved!' : 'Save changes'}
                    buttonClass={updated ? 'blue' : ''} 
                    buttonClick={() => updateSettings(this.state.settings)} 
                />

                <div id="content-body">
                    <div className="settings">
                            <Setting title="Social links">
                                <input onChange={this.handleSocialInput} value={social_links.facebook} name="facebook" type="text" placeholder="Facebook" />
                                <input onChange={this.handleSocialInput} value={social_links.twitter} name="twitter" type="text" placeholder="Twitter" />
                                <input onChange={this.handleSocialInput} value={social_links.vimeo} name="vimeo" type="text" placeholder="Vimeo" />
                                <input onChange={this.handleSocialInput} value={social_links.soundcloud} name="soundcloud" type="text" placeholder="Soundcloud" />
                                <input onChange={this.handleSocialInput} value={social_links.instagram} name="instagram" type="text" placeholder="Instagram" />
                            </Setting>
                        
                        <Setting title="Headlines">
                            <div className="headlines">
                                <ul>
                                    {header_headlines.map((headline,index) => 
                                        <li key={index} onClick={() => this.deleteHeadline(headline)}>{headline}</li>
                                    )}
                                    
                                    {addHeadline && 
                                        <div className="input">
                                            <input ref="newHeadline" placeholder="New headline" autoFocus/>
                                            <button onClick={this.handleAddHeadline}>Save</button>
                                        </div>
                                    }

                                    <button onClick={this.toggleAddHeadline} className="addHeadline">{addHeadline ? 'Cancel' : `+ Add new headline`}</button>
                                </ul>
                            </div>
                        </Setting>

                        <Setting title="Email receiver">
                            <input onChange={this.handleEmailReceiverInput} value={email_receiver} type="text" placeholder="E-mail receiver" />
                        </Setting>
                        
                    </div>
                </div>
            </div>
        )
    }
}

const Setting = ({ title, children }) => (
    <div className="setting">
        <div className="setting-header">
            <h1>{title}</h1>
        </div>
        <div className="setting-body">
            {children}
        </div>
    </div>
)

const mapStateToProps = ({ settings: { settings, updated } }) => ({
    settings,
    updated
})

const mapDispatchToProps = dispatch => bindActionCreators({
    getSettings,
    updateSettings
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Settings)


// WEBPACK FOOTER //
// ./src/containers/settings/index.js